import {
  put, takeLatest, call, all, fork,
} from 'redux-saga/effects';
import { isFunction } from 'lodash';
import {
  LOGIN_HISTORY, USER_LIST, USER_BALANCES, USER_INFO, USER_LOGIN_HISTORY, USER_LIST_ADDRESS,
  USER_SYSTEM_LIST,
  USER_SYSTEM_INFO,
  LOCK_USER,
  UNLOCK_USER,
} from '../actions/user/action_types';

import actions from '../actions/user';
import rf from '../../requests/RequestFactory';
import utils from '../../common/utils';

// saga effect

function* fetchUserBalances(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').userBalances(params), action.params);
    yield put(actions.userBalancesActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      action.callback();
    }
  } catch (err) {
    yield put(actions.userBalancesActionFailed(err));
  }
}

function* fetchLoginHistory(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').loginHistories(params), action.params);

    if (isFunction(action.callback)) {
      yield action.callback(resp.total_count);
    }
    yield put(actions.loginHistoryActionSucceed(resp.data));
  } catch (err) {
    yield put(actions.loginHistoryActionFailed(err));
  }
}

function* fetchUsersPaginate(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').usersPaginate(params), action.params);

    if (isFunction(action.callback)) {
      yield action.callback(resp.total_count);
    }
    yield put(actions.userListActionSucceed(resp.data));
  } catch (err) {
    yield put(actions.userListActionFailed(err));
  }
}

function* fetchUsersInFo(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').userInfo(params), action.params);
    yield put(actions.userInfoActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      yield action.callback(resp.total_count);
    }
  } catch (err) {
    yield put(actions.userInfoActionFailed(err));
  }
}

function* fetchUsersLoginHistory(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').userLoginHistory(params), action.params);
    yield put(actions.userLoginHitoryActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      yield action.callback(resp.total_count);
    }
  } catch (err) {
    yield put(actions.userLoginHitoryActionFailed(err));
  }
}

function* fetchUsersListAddress(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').userListAddress(params), action.params);
    yield put(actions.userListAddressActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      yield action.callback(resp.total_count);
    }
  } catch (err) {
    yield put(actions.userListAddressActionFailed(err));
  }
}

function* userSystemListAction(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').userSystemList(params), action.params);
    yield put(actions.userSystemListActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      yield action.callback(resp.total);
    }
  } catch (err) {
    yield put(actions.userSystemListActionFailed(err));
  }
}

function* userSystemInfoAction(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').userSystemInfo(params), action.params);
    yield put(actions.userSystemInfoActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      yield action.callback(resp.total);
    }
  } catch (err) {
    yield put(actions.userSystemInfoActionFailed(err));
  }
}

function* lockUser(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').lockUser(params), action.params);
    yield put(actions.userSystemInfoActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    yield put(actions.userSystemInfoActionFailed(err));
  }
}

function* unlockUser(action) {
  try {
    const resp = yield call((params) => rf.getRequest('UserRequest').unlockUser(params), action.params);
    yield put(actions.userSystemInfoActionSucceed(resp.data));
    if (isFunction(action.callback)) {
      yield action.callback();
    }
  } catch (err) {
    yield put(actions.userSystemInfoActionFailed(err));
  }
}

function* watchAllUsers() {
  yield takeLatest(LOGIN_HISTORY, fetchLoginHistory);
  yield takeLatest(USER_LIST, fetchUsersPaginate);
  yield takeLatest(USER_BALANCES, fetchUserBalances);
  yield takeLatest(USER_INFO, fetchUsersInFo);
  yield takeLatest(USER_LOGIN_HISTORY, fetchUsersLoginHistory);
  yield takeLatest(USER_LIST_ADDRESS, fetchUsersListAddress);
  yield takeLatest(USER_SYSTEM_LIST, userSystemListAction);
  yield takeLatest(USER_SYSTEM_INFO, userSystemInfoAction);
  yield takeLatest(LOCK_USER, lockUser);
  yield takeLatest(UNLOCK_USER, unlockUser);
}

export default function* rootSaga() {
  yield all([fork(watchAllUsers)]);
}
